import React from "react";
import TranslationWrapper from "../../../../components/TranslationWrapper/TranslationWrapper.tsx";
import { Card, FormLabel, Grid } from "@mui/material";
import CardBody from "../../../../components/Card/CardBody";
import FormTextTC from "../../../../components/Forms/FormTextTC";
import FormAsyncTC from "../../../../components/Forms/FormAsyncTC";
import { useFormContext } from "react-hook-form";
import FormSwitchTC from "../../../../components/Forms/FormSwitchTC";
import FormFile from "../../../../components/Forms/FormFile";
import MenuSyncSettings from "../MenuSyncSettings";

function Aloha() {
  const { menukaartVestigingId } = useFormContext();

  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <Grid container spacing={1} style={{ maxWidth: 1400 }}>
            <Grid item xs={12}>
              <h3>
                <TranslationWrapper tDefault={"NCR Aloha (TIM)"} tKey={"vestigingen.form.ncraloha.headers.ncraloha"} />
              </h3>
            </Grid>
            <FormTextTC name={"apiaccounts__alohaEndpoint"} tKey={"Aloha TIM endpoint (WSDL)"} />
            <FormTextTC name={"apiaccounts__alohaSoapUrl"} tKey={"Aloha TIM endpoint (SOAP)"} />
            <FormTextTC name={"apiaccounts__alohaHardwareId"} tKey={"Aloha TIM hardwareid"} />
            <FormTextTC name={"apiaccounts__alohaSoftwareVersion"} tKey={"Jamezz software version"} />
            <FormTextTC name={"apiaccounts__alohaDeviceName"} tKey={"Jamezz device name"} />
            <FormTextTC name={"apiaccounts__alohaUser"} tKey={"Aloha TIM user"} />
            <FormTextTC name={"apiaccounts__alohaIdentifier"} tKey={"Aloha TIM identifier"} />
            <FormTextTC name={"apiaccounts__alohaProfileID"} tKey={"Aloha profile slot"} />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"apiaccounts__alohaService" + menukaartVestigingId}
              name={"apiaccounts__alohaService"}
              nullable={true}
              tDefault={"Bediening (service)"}
              tKey={"vestigingen.form.apiaccounts.label.serviceProduct_id"}
            />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"apiaccounts__alohaBill" + menukaartVestigingId}
              name={"apiaccounts__alohaBill"}
              nullable={true}
              tDefault={"Rekening (service)"}
              tKey={"vestigingen.form.apiaccounts.label.billProduct_id"}
            />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"apiaccounts__alohaCustomFieldsIDFood" + menukaartVestigingId}
              name={"apiaccounts__alohaCustomFieldsIDFood"}
              nullable={true}
              tKey={"Customfield product eten #"}
            />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"apiaccounts__alohaCustomFieldsIDDrinks" + menukaartVestigingId}
              name={"apiaccounts__alohaCustomFieldsIDDrinks"}
              nullable={true}
              tKey={"Customfield product drinken #"}
            />
            <FormTextTC name={"apiaccounts__alohaCustomOrderMode"} tKey={"Ordermode #"} />
            <FormTextTC name={"apiaccounts__alohaTenderID"} tKey={"Tender ID #"} />
            <FormTextTC name={"apiaccounts__alohaPriceMode"} tKey={"Pricemode #"} />
            <FormTextTC name={"apiaccounts__alohaJobCode"} tKey={"Job Code ID #"} />
            <FormTextTC name={"apiaccounts__alohaCompProduct"} tKey={"Aloha COMP #"} />
            <FormSwitchTC
              name={"apiaccounts__alohaSplitFields"}
              tDefault={"Aloha split fields"}
              tKey={"vestigingen.form.untill.label.alohaSplitFields"}
            />
            <FormSwitchTC
              name={"apiaccounts__alohaCloseOnTicketAmount"}
              tDefault={"Close on ticket value"}
              tKey={"vestigingen.form.untill.label.alohaCloseOnTicketAmount"}
            />
            <FormSwitchTC
              name={"syncTableStateFromPos"}
              tDefault={"Sync table state from POS"}
              tKey={"vestigingen.syncTableStateFromPos"}
            />
            <FormSwitchTC
              name={"custom_data.new_check_paid_orders"}
              tDefault={"Create new check for paid orders"}
              tKey={"vestigingen.new_check_paid_orders"}
            />
            <Grid item sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tDefault={"ITM (DBF)"} tKey={"vestigingen.form.apiaccounts.label.itmdbf"} />
              </FormLabel>
            </Grid>
            <Grid item sm={8} xs={12}>
              <FormFile name={"aloha_itm"} nullable={false} />
            </Grid>
            <Grid item sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tDefault={"SUB (DBF)"} tKey={"vestigingen.form.apiaccounts.label.subdbf"} />
              </FormLabel>
            </Grid>
            <Grid item sm={8} xs={12}>
              <FormFile name={"aloha_sub"} nullable={false} />
            </Grid>
            <Grid item sm={4} xs={12}>
              <FormLabel>
                <TranslationWrapper tDefault={"PCID (DBF)"} tKey={"vestigingen.form.apiaccounts.label.pcid"} />
              </FormLabel>
            </Grid>
            <Grid item sm={8} xs={12}>
              <FormFile name={"aloha_pcid"} nullable={false} />
            </Grid>
            <Grid item xs={12}>
              <h3>
                <TranslationWrapper tKey={"API Settings for getting table state"} />
              </h3>
            </Grid>
            <FormTextTC name={"apiaccounts__alohaEndpointTS"} tKey={"Aloha TIM endpoint (WSDL)"} />
            <FormTextTC name={"apiaccounts__alohaSoapUrlTS"} tKey={"Aloha TIM endpoint (SOAP)"} />
            <FormTextTC name={"apiaccounts__alohaHardwareIdTS"} tKey={"Aloha TIM hardwareid"} />
            <FormTextTC name={"apiaccounts__alohaDeviceNameTS"} tKey={"Jamezz device name"} />
            <FormTextTC name={"apiaccounts__alohaUserTS"} tKey={"Aloha TIM user"} />
            <FormTextTC name={"apiaccounts__alohaProfileIDTS"} tKey={"Aloha TIM identifier"} />
            <FormTextTC name={"apiaccounts__alohaProfileSlotTS"} tKey={"Aloha profile slot, empty auto detect"} />
          </Grid>

          <MenuSyncSettings />
        </CardBody>
      </Card>
    </div>
  );
}

export default Aloha;
